import React, { useEffect, useRef, useState } from 'react'
import { Navigate } from 'react-router-dom'
import { FacturationTab } from '@/components/facturation/FacturationTab'
import { InvoiceSimulationSection } from '@/components/facturation/InvoiceSimulationSection'
import { useFacturationStore } from '@/stores/facturation.store'
import { useAuth } from '@/hooks/useAuth'
import { useImpersonationPath } from '@/hooks/useImpersonationPath'
import { canAccessFacturation, isAdminUser } from '@/utils/role-access'

type FacturationPageTab = 'invoices' | 'simulation'

export const FacturationPage: React.FC = () => {
  const fetchInvoices = useFacturationStore(state => state.fetchInvoices)
  const invoices = useFacturationStore(state => state.invoices)
  const isInitialized = useFacturationStore(state => state.isInitialized)
  const { user } = useAuth()
  const toPath = useImpersonationPath()
  const hasFetchedRef = useRef(false)
  const showSimulationTab = isAdminUser(user)
  const [activeTab, setActiveTab] = useState<FacturationPageTab>('invoices')

  useEffect(() => {
    if (hasFetchedRef.current) return
    hasFetchedRef.current = true

    fetchInvoices().catch(error => {
      console.error('Error loading invoices:', error)
    })
  }, [fetchInvoices])

  if (!canAccessFacturation(user)) {
    return <Navigate to={toPath('/')} replace />
  }

  if (!isInitialized && invoices === null) {
    return (
      <div className="flex items-center justify-center py-12">
        <div className="text-[var(--color-text-secondary)]">Chargement...</div>
      </div>
    )
  }

  return (
    <div>
      {showSimulationTab && (
        <div className="border-b border-[var(--color-border)] mb-6">
          <nav className="flex space-x-8">
            <button
              type="button"
              onClick={() => setActiveTab('invoices')}
              className={`pb-4 px-1 border-b-2 font-medium text-sm transition-colors ${
                activeTab === 'invoices'
                  ? 'border-[var(--color-primary)] text-[var(--color-primary)] font-semibold'
                  : 'border-transparent text-[var(--color-text-secondary)] hover:text-[var(--color-text-primary)] hover:border-[var(--color-border)]'
              }`}
            >
              Factures
            </button>
            <button
              type="button"
              onClick={() => setActiveTab('simulation')}
              className={`pb-4 px-1 border-b-2 font-medium text-sm transition-colors ${
                activeTab === 'simulation'
                  ? 'border-[var(--color-primary)] text-[var(--color-primary)] font-semibold'
                  : 'border-transparent text-[var(--color-text-secondary)] hover:text-[var(--color-text-primary)] hover:border-[var(--color-border)]'
              }`}
            >
              Simulation
            </button>
          </nav>
        </div>
      )}

      {activeTab === 'invoices' && <FacturationTab />}
      {activeTab === 'simulation' && showSimulationTab && <InvoiceSimulationSection />}
    </div>
  )
}
